import { Pipe, PipeTransform } from '@angular/core';
import { getFilledIconVariant, InteractaIcon } from '@interacta-shared/util';

@Pipe({
    name: 'filledIcon',
})
export class FilledIconPipe implements PipeTransform {
    transform(icon: InteractaIcon, filled: boolean): InteractaIcon {
        return filled ? getFilledIconVariant(icon) : icon;
    }
}
